export default "__VITE_ASSET__B3S2LP5X__"